/* src/app/components/product-result/product-result.component.less */
/*# sourceMappingURL=product-result.component-TZCDEL72.css.map */
